<template>
  <div class="flex flex-col items-startyarn add dayjs">
    <div class="flex items-center mb-2 gap-2">
      <MazInput v-model="form.first_name"
                label="Prénom"
                :hint="form.errors && form.errors.first_name ? 'Prénom obligatoire' : 'Prénom'"
                :error="form.errors && form.errors.first_name"
                @keydown="form.clearErrors('first_name')"
      />
      <MazInput v-model="form.last_name"
                label="Nom"
                :hint="form.errors && form.errors.last_name ? 'Nom obligatoire' : 'Nom'"
                :error="form.errors && form.errors.last_name"
                @keydown="form.clearErrors('last_name')"
      />
    </div>
    <MazInput v-model="form.email"
              label="Email"
              type="email"
              :hint="form.errors && form.errors.email ? 'Veuillez vérifier l\'email' : 'Email'"
              :error="form.errors && form.errors.email"
              @keydown="form.clearErrors('email')"
    />
    <BubbleButton class="mt-4" @click="send" :disabled="form.processing">Envoyer</BubbleButton>
    <div v-if="form.wasSuccessful"
         class="bg-green-500 text-white font-bold py-2 px-4 rounded-lg mt-4 text-center"
    >
      {{ $trans('app.invitations.sent_success') }}
    </div>
  </div>
</template>

<script>
import MazInput from 'maz-ui/components/MazInput';
import BubbleButton from "@/Components/BubbleButton";

export default {
  name: 'NewInvitation',
  components: {
    MazInput,
    BubbleButton,
  },

  data() {
    return {
      form: this.$inertia.form({
        email: '',
        first_name: '',
        last_name: ''
      }),
    }
  },

  methods: {
    async send() {
      await this.form.post(route('invitation.send'), {
        onSuccess: () => this.form.reset(),
      })
    }
  }
}
</script>
